<div class="d-inline-block {{toggleIcons ? 'button-toggler' : minimal ? 'btn-group-primary-light' : 'btn-group ' + sizeClass + ' small-toggle'}} {{hasError ? 'border border-danger' : ''}} {{hasWarning ? 'border border-warning' : ''}}" role="group">
    <ng-container *ngIf="!toggleIcons">
        <button type="button" (click)="bool = true; change();" class="btn {{bool ? 'active' : ''}}">{{labelTrue | translate}}</button>
        <button type="button" (click)="bool = false; change();" class="btn {{!bool ? 'active' : ''}}">{{labelFalse | translate}}</button>
    </ng-container>
    <ng-container *ngIf="toggleIcons">
        <i class="{{!disabled ? 'cursor-pointer' : 'disabled'}}" [ngClass]="renderIcon()" (click)="bool = !bool; change();"></i>
    </ng-container>
</div>